export default __webpack_public_path__ + "static/media/NeoNX110_LateralDer.ddc020e8.webp";